import { values } from '@direct-frontend/stdlib';
import { getDeliveryServiceSlug } from '../lib/getDeliveryServiceSlug';

/** ======== Branches ======== */
export const SETTINGS_ROOT_SLUG = '' as const;
export const SETTINGS_AI_SLUG = '/ai' as const;
export const SETTINGS_DELIVERY_SLUG = '/delivery' as const;
export const SETTINGS_COMPANY_SLUG = '/company' as const;
export const SETTINGS_ORDER_SLUG = '/order' as const;
export const SETTINGS_INTEGRATIONS_SLUG = '/integrations' as const;
export const SETTINGS_ROUTING_TEMPLATES_DEFAULT_SLUG = '/routing/templates/default' as const;
export const SETTINGS_PAYMENT_SLUG = '/payment' as const;
export const SETTINGS_PROCESSING_SLUG = '/processing' as const;

/** ========================== */

/** ======== Leaves ======== */
/** Delivery */
export const SETTINGS_DELIVERY_YANDEX_SLUG = `${SETTINGS_DELIVERY_SLUG}/yandex_delivery` as const;
export const SETTINGS_DELIVERY_VAT = `${SETTINGS_DELIVERY_SLUG}/vat` as const;
export const SETTINGS_DELIVERY_DISABLE_POST_PAYMENT_SLUG = `${SETTINGS_DELIVERY_SLUG}/disable_postpayment` as const;
export const SETTINGS_DELIVERY_DISABLE_ONLINE_PAYMENT_SLUG =
    `${SETTINGS_DELIVERY_SLUG}/disable_online_payment` as const;
export const SETTINGS_DELIVERY_POST_PAYMENT_MAX_PRICE_SLUG = `${SETTINGS_DELIVERY_SLUG}/postpayment_max_price` as const;
export const SETTINGS_DELIVERY_ENABLE_PARTIAL_REDEMPTION_SLUG =
    `${SETTINGS_DELIVERY_SLUG}/partial_redemption_enabled` as const;
export const SETTINGS_DELIVERY_SERVICES = `${SETTINGS_DELIVERY_SLUG}/services` as const;
export const SETTINGS_DELIVERY_YANDEX_TOKEN =
    `${SETTINGS_DELIVERY_SLUG}/yandex_delivery/yandex_delivery_token` as const;
export const SETTINGS_DELIVERY_CDEK_ACCOUNT = `${SETTINGS_DELIVERY_SLUG}/cdek/cdek_oauth_parameters/account` as const;
export const SETTINGS_DELIVERY_CDEK_PASSWORD = `${SETTINGS_DELIVERY_SLUG}/cdek/cdek_oauth_parameters/password` as const;
export const SETTINGS_DELIVERY_OZON_CUSTOMER_PRICE = `${SETTINGS_DELIVERY_SLUG}/ozon/customer_price` as const;
export const SETTINGS_DELIVERY_DALLI_TOKEN = `${SETTINGS_DELIVERY_SLUG}/meta_ship/dalli/token` as const;
export const SETTINGS_DELIVERY_RUSSIAN_POST_TOKEN = `${SETTINGS_DELIVERY_SLUG}/meta_ship/russian_post/token` as const;
export const SETTINGS_DELIVERY_RUSSIAN_POST_SECRET = `${SETTINGS_DELIVERY_SLUG}/meta_ship/russian_post/secret` as const;
export const SETTINGS_DELIVERY_RUSSIAN_POST_CODE =
    `${SETTINGS_DELIVERY_SLUG}/meta_ship/russian_post/intake_post_office_code` as const;
export const SETTINGS_DELIVERY_PECOM_LOGIN = `${SETTINGS_DELIVERY_SLUG}/meta_ship/pecom/login` as const;
export const SETTINGS_DELIVERY_PECOM_API_KEY = `${SETTINGS_DELIVERY_SLUG}/meta_ship/pecom/api_key` as const;
export const SETTINGS_DELIVERY_PECOM_WAREHOUSE_ID =
    `${SETTINGS_DELIVERY_SLUG}/meta_ship/pecom/sender_warehouse_id` as const;
export const SETTINGS_DELIVERY_YCP_COURIER_ENABLED = `${SETTINGS_DELIVERY_SLUG}/ycp/courier/enabled` as const;
export const SETTINGS_DELIVERY_YCP_PICKUP_POINTS_ENABLED =
    `${SETTINGS_DELIVERY_SLUG}/ycp/pickup_points/enabled` as const;
export const SETTINGS_DELIVERY_YCP_PICKUP_POINTS_NAMING = `${SETTINGS_DELIVERY_SLUG}/ycp/pickup_points/naming` as const;
export const SETTINGS_DELIVERY_YCP_PICKUP_POINTS_LOGO = `${SETTINGS_DELIVERY_SLUG}/ycp/pickup_points/logo` as const;
export const SETTINGS_DELIVERY_DEFAULT_HEIGHT_SLUG = `${SETTINGS_DELIVERY_SLUG}/default_height_centimeters` as const;
export const SETTINGS_DELIVERY_DEFAULT_WIDTH_SLUG = `${SETTINGS_DELIVERY_SLUG}/default_width_centimeters` as const;
export const SETTINGS_DELIVERY_DEFAULT_LENGTH_SLUG = `${SETTINGS_DELIVERY_SLUG}/default_length_centimeters` as const;
export const SETTINGS_DELIVERY_DEFAULT_WEIGHT_SLUG = `${SETTINGS_DELIVERY_SLUG}/default_weight_grams` as const;
export const SETTINGS_DELIVERY_DEFAULT_DELIVERY_METHOD = `${SETTINGS_DELIVERY_SLUG}/default_method` as const;
export const SETTINGS_DELIVERY_ITEM_PER_BOX_ENABLED_SLUG = `${SETTINGS_DELIVERY_SLUG}/item_per_box_enabled` as const;

/** Delivery Services*/
export const SETTINGS_DELIVERY_FREE_DELIVERY_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'free_delivery_from'
);
export const SETTINGS_DELIVERY_FREE_DELIVERY_ENABLED_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'free_delivery_from/enabled'
);
export const SETTINGS_DELIVERY_SELLER_SHIPPING_PERCENT_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'seller_shipping_coverage_percent'
);
export const SETTINGS_DELIVERY_ONLINE_PAYMENT_FREE_DELIVERY_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'online_payment_free_delivery_threshold'
);
export const SETTINGS_DELIVERY_ONLINE_PAYMENT_FREE_DELIVERY_ENABLED_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'online_payment_free_delivery_enabled'
);
export const SETTINGS_DELIVERY_ONLINE_PAYMENT_SELLER_SHIPPING_PERCENT_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'online_payment_seller_coverage_percent'
);
export const SETTINGS_DELIVERY_CASH_ON_FREE_DELIVERY_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'cash_on_delivery_free_delivery_threshold'
);
export const SETTINGS_DELIVERY_CASH_ON_FREE_DELIVERY_ENABLED_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'cash_on_delivery_free_delivery_enabled'
);
export const SETTINGS_DELIVERY_CASH_ON_SELLER_SHIPPING_PERCENT_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'cash_on_delivery_seller_coverage_percent'
);
export const SETTINGS_DELIVERY_PRICE_BASED_ON_PAYMENT_METHOD_SLUG = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'delivery_price_based_on_payment_method'
);
export const SETTINGS_DELIVERY_CRATE_ENABLED_SLUG = getDeliveryServiceSlug(SETTINGS_DELIVERY_SLUG, 'crate_enabled');
export const SETTINGS_DELIVERY_HOLDING_PERIOD_DAYS = getDeliveryServiceSlug(
    SETTINGS_DELIVERY_SLUG,
    'holding_period_days'
);
export const SETTINGS_DELIVERY_PARTNERS_SLUG = getDeliveryServiceSlug(SETTINGS_DELIVERY_SLUG, 'partners');

/** Company */
export const SETTINGS_COMPANY_TITLE_SLUG = `${SETTINGS_COMPANY_SLUG}/title` as const;
export const SETTINGS_COMPANY_NAME_SLUG = `${SETTINGS_COMPANY_SLUG}/name` as const;
export const SETTINGS_COMPANY_LEGAL_NAME_SLUG = `${SETTINGS_COMPANY_SLUG}/legal_name` as const;
export const SETTINGS_COMPANY_DESCRIPTION_SLUG = `${SETTINGS_COMPANY_SLUG}/description` as const;
export const SETTINGS_COMPANY_LOGO_SLUG = `${SETTINGS_COMPANY_SLUG}/logo` as const;
export const SETTINGS_COMPANY_INVERTED_LOGO_SLUG = `${SETTINGS_COMPANY_SLUG}/inverted_logo` as const;
export const SETTINGS_COMPANY_FAVICON_SLUG = `${SETTINGS_COMPANY_SLUG}/favicon` as const;
export const SETTINGS_COMPANY_RCCT_SLUG = `${SETTINGS_COMPANY_SLUG}/retail_crm/rcct` as const;
export const SETTINGS_COMPANY_HOME_SLUG = `${SETTINGS_COMPANY_SLUG}/home` as const;
export const SETTINGS_COMPANY_PHONES = `${SETTINGS_COMPANY_SLUG}/phones` as const;
export const SETTINGS_COMPANY_ADDRESSES = `${SETTINGS_COMPANY_SLUG}/addresses` as const;
export const SETTINGS_COMPANY_EMAILS = `${SETTINGS_COMPANY_SLUG}/emails` as const;
export const SETTINGS_COMPANY_WORKING_MODES = `${SETTINGS_COMPANY_SLUG}/working_modes` as const;
export const SETTINGS_COMPANY_SOCIAL_NETWORKS_SLUG = `${SETTINGS_COMPANY_SLUG}/social_networks` as const;
export const SETTINGS_COMPANY_YANDEX_METRIKA_ID = `${SETTINGS_COMPANY_SLUG}/yandex_metric/counter` as const;
export const SETTINGS_COMPANY_TRUTHFUL_LABELS_ENABLED =
    `${SETTINGS_COMPANY_SLUG}/truthful_labels_handling_enabled` as const;
export const SETTINGS_COMPANY_INN_CONFIRMED = `${SETTINGS_COMPANY_SLUG}/inn_confirmed` as const;
export const SETTINGS_COMPANY_HIDE_NON_DELEGATE_DOMAIN_SETUP =
    `${SETTINGS_COMPANY_SLUG}/yandex_cloud/hide_non_delegate_domain_setup` as const;
export const SETTINGS_COMPANY_CHECKOUT_BUTTON_REQUEST_STATUS =
    `${SETTINGS_COMPANY_SLUG}/checkout_button_request_status` as const;
export const SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_SENDING_METHOD =
    `${SETTINGS_COMPANY_SLUG}/order_email_notification/sending_method` as const;
export const SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_SENDING_METHOD =
    `${SETTINGS_COMPANY_SLUG}/promo_email_notification/sending_method` as const;

/** Email Notifications */
export const SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_EMAIL =
    `${SETTINGS_COMPANY_SLUG}/promo_email_notification/email` as const;
export const SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_PASSWORD =
    `${SETTINGS_COMPANY_SLUG}/promo_email_notification/password` as const;
export const SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_POSTBOX_EMAIL =
    `${SETTINGS_COMPANY_SLUG}/promo_email_notification/postbox_email` as const;
export const SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_ALIAS =
    `${SETTINGS_COMPANY_SLUG}/promo_email_notification/alias` as const;
export const SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_ENABLED =
    `${SETTINGS_COMPANY_SLUG}/order_email_notification/order_email_notification_enabled` as const;
export const SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_EMAIL =
    `${SETTINGS_COMPANY_SLUG}/order_email_notification/email` as const;
export const SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_PASSWORD =
    `${SETTINGS_COMPANY_SLUG}/order_email_notification/password` as const;
export const SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_POSTBOX_EMAIL =
    `${SETTINGS_COMPANY_SLUG}/order_email_notification/postbox_email` as const;
export const SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_ALIAS =
    `${SETTINGS_COMPANY_SLUG}/order_email_notification/alias` as const;

/** Abandoned cart email notifications */
export const SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_ENABLED =
    '/notifications/abandoned_cart_email/enabled' as const;
export const SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_DELAY_HOURS =
    '/notifications/abandoned_cart_email/delay_hours' as const;
export const SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_PROMOCODE_ID =
    '/notifications/abandoned_cart_email/promocode_id' as const;
export const SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_THROTTLE_DAYS =
    '/notifications/abandoned_cart_email/throttle_days' as const;

/** UTM-атрибуция */
export const SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_IS_ENABLED_SLUG =
    `${SETTINGS_COMPANY_SLUG}/utm_attribution_rules/is_enabled` as const;
export const SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_PAID_UTM_SOURCES_SLUG =
    `${SETTINGS_COMPANY_SLUG}/utm_attribution_rules/paid_utm_sources` as const;
export const SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_WINDOW_OF_DAYS_SLUG =
    `${SETTINGS_COMPANY_SLUG}/utm_attribution_rules/window_of_days` as const;
/** ======================== */

/** KitAI */
export const SETTINGS_AI_DOCUMENTS_SLUG = `${SETTINGS_AI_SLUG}/neuroexpert/documents` as const;
export const SETTINGS_AI_ENABLED_SLUG = `${SETTINGS_AI_SLUG}/neuroexpert/enabled` as const;
export const SETTINGS_AI_COLLECTION_AUTO_PUBLISHING_ENABLED_SLUG =
    `${SETTINGS_AI_SLUG}/collection_auto_publishing` as const;
export const SETTINGS_AI_COLLECTION_AUTO_QUICK_FILTERS_ENABLED_SLUG =
    `${SETTINGS_AI_SLUG}/collection_auto_quick_filters` as const;
/** ======================== */

export const SETTINGS_SEO_PRODUCT_TITLE =
    `${SETTINGS_ROUTING_TEMPLATES_DEFAULT_SLUG}/default_product_seo_title` as const;
export const SETTINGS_SEO_PRODUCT_DESCRIPTION =
    `${SETTINGS_ROUTING_TEMPLATES_DEFAULT_SLUG}/default_product_seo_description` as const;
export const SETTINGS_SEO_LISTING_TITLE =
    `${SETTINGS_ROUTING_TEMPLATES_DEFAULT_SLUG}/default_listing_seo_title` as const;
export const SETTINGS_SEO_LISTING_DESCRIPTION =
    `${SETTINGS_ROUTING_TEMPLATES_DEFAULT_SLUG}/default_listing_seo_description` as const;
export const SETTINGS_SEO_STATIC_TITLE =
    `${SETTINGS_ROUTING_TEMPLATES_DEFAULT_SLUG}/default_static_page_seo_title` as const;
export const SETTINGS_SEO_STATIC_DESCRIPTION =
    `${SETTINGS_ROUTING_TEMPLATES_DEFAULT_SLUG}/default_static_page_seo_description` as const;

/** Настройки видимости страниц */
export const SETTINGS_ROUTING_PAGES_SUBSCRIBE_ENABLED = '/routing/pages/subscribe/enabled' as const;
/** ======================== */

/** Ручное подтверждение заказа */
export const SETTINGS_ORDER_CONFIRMATION_ENABLED = `/order_confirmation_enabled` as const;
/** ======================== */

/** Настройки заказа */
export const SETTINGS_CHECKOUT_UPSELL_ENABLED = '/checkout/upsell/enabled' as const;
export const SETTINGS_ORDER_MIN_PRICE_LIMIT = `${SETTINGS_ORDER_SLUG}/min_price_limit` as const;
export const SETTINGS_ORDER_MIN_PRICE_LIMIT_ENABLED = `${SETTINGS_ORDER_SLUG}/min_price_limit_enabled` as const;
/** ======================== */

/** Платежные сервисы */
export const SETTINGS_PAYMENT_CLOUD_PAYMENTS_PRIVATE_KEY_SLUG =
    '/payment_systems/cloudpayments/cloudpayments_private_key' as const;
export const SETTINGS_PAYMENT_CLOUD_PAYMENTS_PUBLIC_KEY_SLUG =
    '/payment_systems/cloudpayments/cloudpayments_public_key' as const;
export const SETTINGS_PAYMENT_YANDEX_PAY_MERCHANT_ID_SLUG =
    '/payment_systems/yandex_pay/yandex_pay_merchant_id' as const;
export const SETTINGS_PAYMENT_YANDEX_PAY_TOKEN_SLUG = '/payment_systems/yandex_pay/yandex_pay_token' as const;
export const SETTINGS_PAYMENT_OZON_PAY_ACCESS_KEY_SLUG = '/payment_systems/ozon_pay/access_key' as const;
export const SETTINGS_PAYMENT_OZON_PAY_SECRET_KEY_SLUG = '/payment_systems/ozon_pay/secret_key' as const;
export const SETTINGS_PAYMENT_AUTHORIZED_ACQUIRING_SLUG = '/payment_systems/acquiring_non_anonymous_payment' as const;
export const SETTINGS_PAYMENT_ANONYMOUS_ACQUIRING_SLUG = '/payment_systems/acquiring_anonymous_payment' as const;

/** Онлайн-касса */
export const SETTINGS_PAYMENT_CASHIER_SLUG = '/kassa/cashier' as const;
export const SETTINGS_PAYMENT_OWN_CASHIER_SELECTED_SLUG = '/kassa/own_cashier_selected' as const;
export const SETTINGS_PAYMENT_ATOL_LOGIN_SLUG = '/kassa/atol/login' as const;
export const SETTINGS_PAYMENT_ATOL_PASSWORD_SLUG = '/kassa/atol/password' as const;
export const SETTINGS_PAYMENT_ATOL_GROUP_CODE_SLUG = '/kassa/atol/group_code' as const;
export const SETTINGS_PAYMENT_ATOL_TAX_SYSTEM_SLUG = '/kassa/atol/tax_system' as const;
export const SETTINGS_PAYMENT_CLOUD_KASSIR_TAX_SYSTEM_SLUG = '/kassa/cloud_kassir/tax_system' as const;

/** Оплата */
export const SETTINGS_PAYMENT_ENABLE_SELF_PICKUP_POSTPAYMENT_SLUG =
    `${SETTINGS_PAYMENT_SLUG}/enable_self_pickup_postpayment` as const;
export const SETTINGS_PAYMENT_ENABLE_SELF_PICKUP_ONLINE_PAYMENT_SLUG =
    `${SETTINGS_PAYMENT_SLUG}/enable_self_pickup_online_payment` as const;

/** Процессинг заказов */
export const SETTINGS_PROCESSING_ORDERS_DELIVERY_AUTOMATION_ENABLED_SLUG =
    `${SETTINGS_PROCESSING_SLUG}/orders/delivery_automation_enabled` as const;
export const SETTINGS_PROCESSING_ORDERS_RECEIPTS_AUTOMATION_ENABLED_SLUG =
    `${SETTINGS_PROCESSING_SLUG}/orders/receipts_automation_enabled` as const;
export const SETTINGS_PROCESSING_ORDERS_REFUNDS_AUTOMATION_ENABLED_SLUG =
    `${SETTINGS_PROCESSING_SLUG}/orders/refunds_automation_enabled` as const;

/** Конструктор */
export const SETTINGS_ENABLE_CONSTRUCTOR_TEMPLATES_SLUG = `/enable_constructor_templates` as const;
export const SETTINGS_ENABLE_CONSTRUCTOR_SCRIPTS_SLUG = `/enable_constructor_scripts` as const;
export const SETTINGS_CONSTRUCTOR_PAGES_LIMIT = '/limits/count/pages' as const;
export const SETTINGS_CONSTRUCTOR_SECTIONS_LIMIT = '/limits/count/sections' as const;
export const SETTINGS_CONSTRUCTOR_MODULES_LIMIT = '/limits/count/sections/modules' as const;

/** Интеграции CRM */
export const SETTINGS_INTEGRATIONS_CRM_BITRIX24_KEY_SLUG = `${SETTINGS_INTEGRATIONS_SLUG}/crm/bitrix24/key` as const;
export const SETTINGS_INTEGRATIONS_CRM_BITRIX24_IS_ENABLED_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/bitrix24/is_enabled` as const;
export const SETTINGS_INTEGRATIONS_CRM_BITRIX24_URL_SLUG = `${SETTINGS_INTEGRATIONS_SLUG}/crm/bitrix24/url` as const;
export const SETTINGS_INTEGRATIONS_CRM_AMOCRM_KEY_SLUG = `${SETTINGS_INTEGRATIONS_SLUG}/crm/amocrm/key` as const;
export const SETTINGS_INTEGRATIONS_CRM_AMOCRM_IS_ENABLED_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/amocrm/is_enabled` as const;
export const SETTINGS_INTEGRATIONS_CRM_AMOCRM_URL_SLUG = `${SETTINGS_INTEGRATIONS_SLUG}/crm/amocrm/url` as const;
export const SETTINGS_INTEGRATIONS_CRM_MINDBOX_KEY_SLUG = `${SETTINGS_INTEGRATIONS_SLUG}/crm/mindbox/key` as const;
export const SETTINGS_INTEGRATIONS_CRM_MINDBOX_IS_ENABLED_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/mindbox/is_enabled` as const;
export const SETTINGS_INTEGRATIONS_CRM_MINDBOX_DOMAIN_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/mindbox/domain` as const;
export const SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_KEY_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/universal_retail_crm/key` as const;
export const SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_IS_ENABLED_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/universal_retail_crm/is_enabled` as const;
export const SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_URL_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/universal_retail_crm/url` as const;
export const SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_CRM_URL_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/universal_retail_crm/crm_url` as const;
export const SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_CONSULTANT_ENABLED_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/universal_retail_crm/consultant_enabled` as const;
export const SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_TRACKER_ENABLED_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/crm/universal_retail_crm/tracker_enabled` as const;

/** Интеграции — Admitad */
export const SETTINGS_INTEGRATIONS_ADMITAD_IS_ENABLED_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/admitad/is_enabled` as const;
export const SETTINGS_INTEGRATIONS_ADMITAD_CAMPAIGN_CODE_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/admitad/campaign_code` as const;
export const SETTINGS_INTEGRATIONS_ADMITAD_POSTBACK_KEY_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/admitad/postback_key` as const;
export const SETTINGS_INTEGRATIONS_ADMITAD_ACTION_CODE_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/admitad/action_code` as const;
export const SETTINGS_INTEGRATIONS_ADMITAD_TARIFF_CODE_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/admitad/tariff_code` as const;

/** Интеграции Директ */
export const SETTINGS_INTEGRATIONS_DIRECT_AI_PRODUCT_SEARCH_TEXTS_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/direct/enable_ai_product_search_texts` as const;

export const SETTINGS_INTEGRATIONS_GOODS_AI_PRODUCT_SEARCH_TEXTS_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/goods/enable_ai_product_search_texts` as const;

/** Интеграции ERP */
export const SETTINGS_INTEGRATIONS_ERP_YANDEX_MARKET_TOKEN_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/erp/yandex_market/token` as const;
export const SETTINGS_INTEGRATIONS_ERP_YANDEX_MARKET_CAMPAIGN_ID_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/erp/yandex_market/laas_campaign_id` as const;

/** Интеграции — программа лояльности */
export const SETTINGS_INTEGRATIONS_LOYALTY_KEY_SLUG = `${SETTINGS_INTEGRATIONS_SLUG}/loyalty/key` as const;
export const SETTINGS_INTEGRATIONS_LOYALTY_ENABLED_SLUG = `${SETTINGS_INTEGRATIONS_SLUG}/loyalty/enabled` as const;
export const SETTINGS_INTEGRATIONS_LOYALTY_BONUS_CHARGE_RATE_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/loyalty/bonus_charge_rate` as const;
export const SETTINGS_INTEGRATIONS_LOYALTY_MAX_BONUS_DISCOUNT_PERCENT_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/loyalty/max_bonus_discount_percent` as const;
export const SETTINGS_INTEGRATIONS_LOYALTY_BONUS_EXPIRE_RULES_TYPE_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/loyalty/bonus_expire_rules_type` as const;
export const SETTINGS_INTEGRATIONS_LOYALTY_BONUS_EXPIRE_RULES_PERIOD_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/loyalty/bonus_expire_rules_period` as const;
export const SETTINGS_INTEGRATIONS_LOYALTY_WELCOME_BONUS_ACTIVATION_TYPE_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/loyalty/welcome_bonus_activation_type` as const;
export const SETTINGS_INTEGRATIONS_LOYALTY_WELCOME_BONUS_EXPIRE_PERIOD_SLUG =
    `${SETTINGS_INTEGRATIONS_SLUG}/loyalty/welcome_bonus_expire_period` as const;

/** Подключаемые модули */
export const SETTINGS_PLUGIN_CHECKOUT_1C_BITRIX_MODULE = '/plugin/checkout/bitrix/module_url' as const;
/** ======================== */

/** Feature flags */
export const SETTINGS_FEATURE_FLAGS_ENABLE_CONSOLIDATED_STOCK_ALLOCATION =
    '/feature_flags/enable_consolidated_stock_allocation' as const;
export const SETTINGS_FEATURE_FLAGS_PROMO_ON_PDP = '/feature_flags/promo_on_pdp' as const;
export const SETTINGS_FEATURE_FLAGS_INTAKE_GROUP_ENABLED = '/feature_flags/intake_group_enabled' as const;
export const SETTINGS_FEATURE_FLAGS_GOOD_PRICE_BADGE_ENABLED = '/feature_flags/enable_good_price_badge' as const;
export const SETTINGS_FEATURE_FLAGS_ENABLE_RETAILCRM_UNIVERSAL_UI =
    '/feature_flags/enable_retailcrm_universal_ui' as const;
export const SETTINGS_FEATURE_FLAGS_PROCESS_RECEIPTS_ASYNC_ENABLED =
    '/feature_flags/process_receipts_async_enabled' as const;
export const SETTINGS_FEATURE_FLAGS_ENABLE_FISCAL_MARKING_CODE_VALIDATION =
    '/feature_flags/enable_fiscal_marking_code_validation' as const;
/** ======================== */

//  Все пути до настроек
export const SETTINGS_LEAVES = {
    SETTINGS_DELIVERY_VAT,
    SETTINGS_DELIVERY_DISABLE_POST_PAYMENT_SLUG,
    SETTINGS_DELIVERY_DISABLE_ONLINE_PAYMENT_SLUG,
    SETTINGS_DELIVERY_POST_PAYMENT_MAX_PRICE_SLUG,
    SETTINGS_DELIVERY_ENABLE_PARTIAL_REDEMPTION_SLUG,
    SETTINGS_DELIVERY_ITEM_PER_BOX_ENABLED_SLUG,
    SETTINGS_DELIVERY_SERVICES,
    SETTINGS_DELIVERY_YANDEX_TOKEN,
    SETTINGS_DELIVERY_CDEK_ACCOUNT,
    SETTINGS_DELIVERY_CDEK_PASSWORD,
    SETTINGS_DELIVERY_OZON_CUSTOMER_PRICE,
    SETTINGS_DELIVERY_DALLI_TOKEN,
    SETTINGS_DELIVERY_RUSSIAN_POST_TOKEN,
    SETTINGS_DELIVERY_RUSSIAN_POST_SECRET,
    SETTINGS_DELIVERY_RUSSIAN_POST_CODE,
    SETTINGS_DELIVERY_PECOM_LOGIN,
    SETTINGS_DELIVERY_PECOM_API_KEY,
    SETTINGS_DELIVERY_PECOM_WAREHOUSE_ID,
    SETTINGS_DELIVERY_YCP_COURIER_ENABLED,
    SETTINGS_DELIVERY_YCP_PICKUP_POINTS_ENABLED,
    SETTINGS_DELIVERY_YCP_PICKUP_POINTS_NAMING,
    SETTINGS_DELIVERY_YCP_PICKUP_POINTS_LOGO,
    SETTINGS_DELIVERY_DEFAULT_HEIGHT_SLUG,
    SETTINGS_DELIVERY_DEFAULT_WIDTH_SLUG,
    SETTINGS_DELIVERY_DEFAULT_LENGTH_SLUG,
    SETTINGS_DELIVERY_DEFAULT_WEIGHT_SLUG,
    SETTINGS_DELIVERY_DEFAULT_DELIVERY_METHOD,
    ...SETTINGS_DELIVERY_FREE_DELIVERY_SLUG,
    ...SETTINGS_DELIVERY_FREE_DELIVERY_ENABLED_SLUG,
    ...SETTINGS_DELIVERY_SELLER_SHIPPING_PERCENT_SLUG,
    ...SETTINGS_DELIVERY_ONLINE_PAYMENT_FREE_DELIVERY_SLUG,
    ...SETTINGS_DELIVERY_ONLINE_PAYMENT_FREE_DELIVERY_ENABLED_SLUG,
    ...SETTINGS_DELIVERY_ONLINE_PAYMENT_SELLER_SHIPPING_PERCENT_SLUG,
    ...SETTINGS_DELIVERY_CASH_ON_FREE_DELIVERY_SLUG,
    ...SETTINGS_DELIVERY_CASH_ON_FREE_DELIVERY_ENABLED_SLUG,
    ...SETTINGS_DELIVERY_CASH_ON_SELLER_SHIPPING_PERCENT_SLUG,
    ...SETTINGS_DELIVERY_PRICE_BASED_ON_PAYMENT_METHOD_SLUG,
    ...SETTINGS_DELIVERY_CRATE_ENABLED_SLUG,
    ...SETTINGS_DELIVERY_HOLDING_PERIOD_DAYS,
    ...SETTINGS_DELIVERY_PARTNERS_SLUG,
    SETTINGS_COMPANY_INN_CONFIRMED,
    SETTINGS_COMPANY_TITLE_SLUG,
    SETTINGS_COMPANY_NAME_SLUG,
    SETTINGS_COMPANY_LEGAL_NAME_SLUG,
    SETTINGS_COMPANY_DESCRIPTION_SLUG,
    SETTINGS_COMPANY_RCCT_SLUG,
    SETTINGS_COMPANY_LOGO_SLUG,
    SETTINGS_COMPANY_INVERTED_LOGO_SLUG,
    SETTINGS_COMPANY_FAVICON_SLUG,
    SETTINGS_COMPANY_HOME_SLUG,
    SETTINGS_COMPANY_PHONES,
    SETTINGS_COMPANY_ADDRESSES,
    SETTINGS_COMPANY_EMAILS,
    SETTINGS_COMPANY_WORKING_MODES,
    SETTINGS_COMPANY_SOCIAL_NETWORKS_SLUG,
    SETTINGS_COMPANY_YANDEX_METRIKA_ID,
    SETTINGS_COMPANY_TRUTHFUL_LABELS_ENABLED,
    SETTINGS_COMPANY_HIDE_NON_DELEGATE_DOMAIN_SETUP,
    SETTINGS_COMPANY_CHECKOUT_BUTTON_REQUEST_STATUS,
    SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_SENDING_METHOD,
    SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_SENDING_METHOD,
    SETTINGS_ORDER_CONFIRMATION_ENABLED,
    SETTINGS_ORDER_MIN_PRICE_LIMIT,
    SETTINGS_ORDER_MIN_PRICE_LIMIT_ENABLED,
    SETTINGS_CHECKOUT_UPSELL_ENABLED,
    SETTINGS_AI_COLLECTION_AUTO_PUBLISHING_ENABLED_SLUG,
    SETTINGS_AI_COLLECTION_AUTO_QUICK_FILTERS_ENABLED_SLUG,
    SETTINGS_AI_DOCUMENTS_SLUG,
    SETTINGS_AI_ENABLED_SLUG,
    SETTINGS_PAYMENT_CLOUD_PAYMENTS_PRIVATE_KEY_SLUG,
    SETTINGS_PAYMENT_CLOUD_PAYMENTS_PUBLIC_KEY_SLUG,
    SETTINGS_PAYMENT_YANDEX_PAY_MERCHANT_ID_SLUG,
    SETTINGS_PAYMENT_YANDEX_PAY_TOKEN_SLUG,
    SETTINGS_PAYMENT_OZON_PAY_ACCESS_KEY_SLUG,
    SETTINGS_PAYMENT_OZON_PAY_SECRET_KEY_SLUG,
    SETTINGS_PAYMENT_AUTHORIZED_ACQUIRING_SLUG,
    SETTINGS_PAYMENT_ANONYMOUS_ACQUIRING_SLUG,
    SETTINGS_PAYMENT_CASHIER_SLUG,
    SETTINGS_PAYMENT_OWN_CASHIER_SELECTED_SLUG,
    SETTINGS_PAYMENT_ATOL_LOGIN_SLUG,
    SETTINGS_PAYMENT_ATOL_PASSWORD_SLUG,
    SETTINGS_PAYMENT_ATOL_GROUP_CODE_SLUG,
    SETTINGS_PAYMENT_ATOL_TAX_SYSTEM_SLUG,
    SETTINGS_PAYMENT_CLOUD_KASSIR_TAX_SYSTEM_SLUG,
    SETTINGS_PAYMENT_ENABLE_SELF_PICKUP_POSTPAYMENT_SLUG,
    SETTINGS_PAYMENT_ENABLE_SELF_PICKUP_ONLINE_PAYMENT_SLUG,
    SETTINGS_PROCESSING_ORDERS_DELIVERY_AUTOMATION_ENABLED_SLUG,
    SETTINGS_PROCESSING_ORDERS_RECEIPTS_AUTOMATION_ENABLED_SLUG,
    SETTINGS_PROCESSING_ORDERS_REFUNDS_AUTOMATION_ENABLED_SLUG,
    SETTINGS_SEO_PRODUCT_TITLE,
    SETTINGS_SEO_PRODUCT_DESCRIPTION,
    SETTINGS_SEO_LISTING_TITLE,
    SETTINGS_SEO_LISTING_DESCRIPTION,
    SETTINGS_SEO_STATIC_TITLE,
    SETTINGS_SEO_STATIC_DESCRIPTION,
    SETTINGS_ROUTING_PAGES_SUBSCRIBE_ENABLED,
    SETTINGS_ENABLE_CONSTRUCTOR_TEMPLATES_SLUG,
    SETTINGS_ENABLE_CONSTRUCTOR_SCRIPTS_SLUG,
    SETTINGS_CONSTRUCTOR_PAGES_LIMIT,
    SETTINGS_CONSTRUCTOR_SECTIONS_LIMIT,
    SETTINGS_CONSTRUCTOR_MODULES_LIMIT,
    SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_EMAIL,
    SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_PASSWORD,
    SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_POSTBOX_EMAIL,
    SETTINGS_COMPANY_PROMO_EMAIL_NOTIFICATION_ALIAS,
    SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_ENABLED,
    SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_EMAIL,
    SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_PASSWORD,
    SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_POSTBOX_EMAIL,
    SETTINGS_COMPANY_ORDER_EMAIL_NOTIFICATION_ALIAS,
    SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_ENABLED,
    SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_DELAY_HOURS,
    SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_PROMOCODE_ID,
    SETTINGS_NOTIFICATIONS_ABANDONED_CART_EMAIL_THROTTLE_DAYS,
    SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_IS_ENABLED_SLUG,
    SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_PAID_UTM_SOURCES_SLUG,
    SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_WINDOW_OF_DAYS_SLUG,
    SETTINGS_INTEGRATIONS_CRM_BITRIX24_KEY_SLUG,
    SETTINGS_INTEGRATIONS_CRM_BITRIX24_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_BITRIX24_URL_SLUG,
    SETTINGS_INTEGRATIONS_CRM_AMOCRM_KEY_SLUG,
    SETTINGS_INTEGRATIONS_CRM_AMOCRM_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_AMOCRM_URL_SLUG,
    SETTINGS_INTEGRATIONS_CRM_MINDBOX_KEY_SLUG,
    SETTINGS_INTEGRATIONS_CRM_MINDBOX_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_MINDBOX_DOMAIN_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_CAMPAIGN_CODE_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_POSTBACK_KEY_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_ACTION_CODE_SLUG,
    SETTINGS_INTEGRATIONS_ADMITAD_TARIFF_CODE_SLUG,
    SETTINGS_INTEGRATIONS_DIRECT_AI_PRODUCT_SEARCH_TEXTS_SLUG,
    SETTINGS_INTEGRATIONS_GOODS_AI_PRODUCT_SEARCH_TEXTS_SLUG,
    SETTINGS_INTEGRATIONS_ERP_YANDEX_MARKET_TOKEN_SLUG,
    SETTINGS_INTEGRATIONS_ERP_YANDEX_MARKET_CAMPAIGN_ID_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_KEY_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_IS_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_URL_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_CRM_URL_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_CONSULTANT_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_CRM_UNIVERSAL_RETAIL_CRM_TRACKER_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_KEY_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_ENABLED_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_BONUS_CHARGE_RATE_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_MAX_BONUS_DISCOUNT_PERCENT_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_BONUS_EXPIRE_RULES_TYPE_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_BONUS_EXPIRE_RULES_PERIOD_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_WELCOME_BONUS_ACTIVATION_TYPE_SLUG,
    SETTINGS_INTEGRATIONS_LOYALTY_WELCOME_BONUS_EXPIRE_PERIOD_SLUG,
    SETTINGS_PLUGIN_CHECKOUT_1C_BITRIX_MODULE,
    SETTINGS_FEATURE_FLAGS_ENABLE_CONSOLIDATED_STOCK_ALLOCATION,
    SETTINGS_FEATURE_FLAGS_PROMO_ON_PDP,
    SETTINGS_FEATURE_FLAGS_INTAKE_GROUP_ENABLED,
    SETTINGS_FEATURE_FLAGS_GOOD_PRICE_BADGE_ENABLED,
    SETTINGS_FEATURE_FLAGS_ENABLE_RETAILCRM_UNIVERSAL_UI,
    SETTINGS_FEATURE_FLAGS_PROCESS_RECEIPTS_ASYNC_ENABLED,
    SETTINGS_FEATURE_FLAGS_ENABLE_FISCAL_MARKING_CODE_VALIDATION,
} as const;

//  Пути для настроек, связанных с комплексными формами
export const SETTINGS_LEAVES_NON_PRIMITIVES_ARRAY = values({
    ...SETTINGS_DELIVERY_FREE_DELIVERY_SLUG,
    ...SETTINGS_DELIVERY_FREE_DELIVERY_ENABLED_SLUG,
    ...SETTINGS_DELIVERY_SELLER_SHIPPING_PERCENT_SLUG,
    ...SETTINGS_DELIVERY_ONLINE_PAYMENT_FREE_DELIVERY_SLUG,
    ...SETTINGS_DELIVERY_ONLINE_PAYMENT_FREE_DELIVERY_ENABLED_SLUG,
    ...SETTINGS_DELIVERY_ONLINE_PAYMENT_SELLER_SHIPPING_PERCENT_SLUG,
    ...SETTINGS_DELIVERY_CASH_ON_FREE_DELIVERY_SLUG,
    ...SETTINGS_DELIVERY_CASH_ON_FREE_DELIVERY_ENABLED_SLUG,
    ...SETTINGS_DELIVERY_CASH_ON_SELLER_SHIPPING_PERCENT_SLUG,
    SETTINGS_COMPANY_LOGO_SLUG,
    SETTINGS_COMPANY_INVERTED_LOGO_SLUG,
    SETTINGS_COMPANY_FAVICON_SLUG,
    SETTINGS_COMPANY_PHONES,
    SETTINGS_COMPANY_ADDRESSES,
    SETTINGS_COMPANY_EMAILS,
    SETTINGS_COMPANY_WORKING_MODES,
    SETTINGS_COMPANY_SOCIAL_NETWORKS_SLUG,
    SETTINGS_COMPANY_UTM_ATTRIBUTION_RULES_PAID_UTM_SOURCES_SLUG,
    SETTINGS_AI_DOCUMENTS_SLUG,
    SETTINGS_AI_ENABLED_SLUG,
});
